import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  padding: ${props => props.theme.spacing.sp24};
  flex-direction: column;
  align-items: flex-start;
  gap: ${props => props.theme.spacing.sp32};
  align-self: stretch;
  border-radius: ${props => props.theme.primitives.radius.radius6};
  background-color: ${props => props.theme.colors.background.secondary};
`

export const TriggersList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  width: 100%;
`

export const TriggerItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  width: 100%;
`

export const CombinatorContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

export const AddTriggerSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  width: 100%;
`
